// Backend timestamps are UTC instants, but most arrive WITHOUT a timezone
// suffix ("2026-07-04T09:51:00.123"): Mongo returns naive datetimes and
// .isoformat() adds no offset. JavaScript parses offset-less date-time strings
// as the VIEWER'S LOCAL time, which skews every "Xh ago" and clock display by
// the local UTC offset (in IST a fresh run showed "Last 5h ago").
//
// Drop-in replacement for `new Date(value)` on backend timestamps:
//  - offset-less date-time string  -> parsed as UTC (appends "Z")
//  - string with Z/±hh:mm          -> unchanged
//  - date-only string ("2026-07-04") -> unchanged (spec already parses as UTC)
//  - Date / epoch number / invalid -> same behavior as new Date(value)
export function parseUtc(value) {
  if (
    typeof value === 'string' &&
    /T\d{2}:\d{2}/.test(value) &&
    !/([zZ]|[+-]\d{2}:?\d{2})$/.test(value)
  ) {
    return new Date(value + 'Z');
  }
  return new Date(value);
}
